export default class ReviewStatus {
    get STATUS() {
        return {
            ERROR: `error`,
            WARNING: `warning`
        }
    }

    constructor(status = `error`, item, message) {
        this.status = status;
        this.item = item;
        this.name = item?.displayName;
        this.message = message;
        this.glyph = status === `error` ? `fa-circle-xmark` : `fa-circle-exclamation`;
        this.variant = status === `error` ? `danger` : `warning`;
    }
}
